import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { Location, useLocation } from 'react-router-dom';

const InitialLocationContext = createContext<null | Location<unknown>>(null);

/**
 * **⚠️ Use sparingly, as this will ONLY be the very first location captured.**
 *
 * Hook to access the initial location when the tree was rendered and provides it for descendants to reference.
 * Useful to retrieve the initial URL.
 */
export function useInitialLocation() {
  const context = useContext(InitialLocationContext);
  if (!context) {
    throw new Error(
      'useInitialLocation must be used within an InitialLocationProvider',
    );
  }

  return context;
}

export default function InitialLocationProvider({
  children,
}: PropsWithChildren) {
  const location = useLocation();
  const [initialLocation] = useState(location);

  return (
    <InitialLocationContext.Provider value={initialLocation}>
      {children}
    </InitialLocationContext.Provider>
  );
}
